import React from 'react';

/**
 * Hidden "honeypot" field used to catch spam bots.
 *
 * Real users never see or fill this input (it's pushed off-screen and hidden
 * from assistive tech). Bots that blindly fill every field will populate it,
 * and the API silently drops any submission where it isn't empty.
 *
 * Props:
 *   value      - current value (should stay "")
 *   onChange   - called with the raw event when the field changes
 */
const hiddenStyle = {
    position: 'absolute',
    left: '-9999px',
    top: 'auto',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    opacity: 0,
};

const Honeypot = ({ value, onChange }) => (
    <div style={hiddenStyle} aria-hidden="true">
        <input
            type="text"
            name="website"
            tabIndex="-1"
            autoComplete="off"
            value={value}
            onChange={onChange}
        />
    </div>
);

export default Honeypot;
